var _circle, _g, _rect, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddCircleDotted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.769,
    cy: 17.353,
    r: 15.895,
    stroke: "#EFF0F7",
    strokeWidth: 2.294
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add-circle-dotted_svg__clip0_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: 1,
    stroke: "#fff",
    strokeWidth: "90%"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.773 11.617v11.47M12.04 17.354h11.47",
    stroke: "currentColor",
    strokeWidth: 1.147,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.466,
    y: 1.048,
    width: 32.609,
    height: 32.609,
    rx: 16.305,
    stroke: "currentColor",
    strokeWidth: 1.147,
    strokeDasharray: "4.59 4.59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add-circle-dotted_svg__clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.039,
    y: 1.621,
    width: 31.462,
    height: 31.462,
    rx: 15.731,
    fill: "#fff"
  })))));
}

export default SvgAddCircleDotted;